















import mixins from 'vue-typed-mixins';
import UserAgreementUtils, { UserAgreement } from '@/utils/UserAgreementUtils';
export default mixins().extend({
  computed: {
    headers(): any {
      return [
        { text: this.$tc('model.useragreement.name'), value: 'name' },
        { text: this.$tc('model.useragreement.active'), value: 'active' },
      ];
    },
  },

  data(): {
    items?: UserAgreement[];
  } {
    return {
      items: undefined,
    };
  },

  async mounted() {
    try {
      this.items = await UserAgreementUtils.api.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async create() {
      await this.$router.push({
        name: 'useragreement-create',
      });
    },

    async edit(item: UserAgreement) {
      await this.$router.push({
        name: 'useragreement-edit',
        params: { id: `${item.id}` },
      });
    },

    async remove(item: UserAgreement) {
      try {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [item.name])
            .toString(),
          async () => {
            if (item.id && this.items) {
              await UserAgreementUtils.api.remove(item.id);

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [item.name],
                }),
              });

              const index = this.items.findIndex((val) => val.id === item.id);
              if (index >= 0) {
                this.items.splice(index, 1);
              }
            }
          }
        );
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
